import { useCallback } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { getGaDataObject } from "@features/pulse/utils/helpers";
import { SanitizedPulseData } from "@features/pulse/utils/types";
import posthog from "posthog-js";

/**
 * This hook is used to send Google Analytics data for Pulse articles.
 * It provides functions to send tracking data and custom events to Google Tag Manager.
 */
export default function useSendPulseGaData() {
  const sendDataToGTM = useGTMDispatch();

  const sendTrackingData = useCallback(
    (
      title: string,
      virtualUrl: string,
      articleId?: string,
      articles?: SanitizedPulseData[],
      pagination?: string
    ) => {
      const gaDataObject = getGaDataObject(
        title,
        virtualUrl,
        articleId,
        articles,
        pagination
      );
      sendDataToGTM(gaDataObject);
    },
    [sendDataToGTM]
  );

  const sendCustomEvent = useCallback(
    (eventAction: string, eventLabel: string) => {
      const trackingData = {
        event: "custom_event",
        eventCategory: "bt pulse",
        eventAction,
        eventLabel,
      };

      sendDataToGTM(trackingData);

      posthog.capture("custom_event", trackingData);
    },

    [sendDataToGTM]
  );

  return { sendTrackingData, sendCustomEvent };
}
